import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
	MatterAdjustmentSalePrice,
	MatterAdjustmentSalePriceCalculated,
	MatterAdjustmentSalePriceHSTCalculated,
} from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { AdjustmentsDispatch } from '@state/matter/adjustments';
import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
	selector: 'app-hst-sale-price-dialog',
	templateUrl: './hst-sale-price-dialog.component.html',
	standalone: false,
})
export class HstSalePriceDialogComponent implements OnInit {
	@ViewSelectSnapshot(AdjustmentsSelector.salePriceHSTCalculated)
	salePriceHSTCalculated: MatterAdjustmentSalePriceHSTCalculated;
	@ViewSelectSnapshot(AdjustmentsSelector.salePriceAdjustmentCalculated)
	salePriceAdjustmentCalculated: MatterAdjustmentSalePriceCalculated;
	@Select(AdjustmentsSelector.salePriceAdjustment)
	salePriceAdjustment$: Observable<MatterAdjustmentSalePrice>;

	public salePriceAdjustment: MatterAdjustmentSalePrice;

	constructor(
		private dialogRef: MatDialogRef<HstSalePriceDialogComponent>,
		private adjustmentDispatch: AdjustmentsDispatch,
	) {}

	ngOnInit() {
		this.salePriceAdjustment$
			.pipe(untilDestroyed(this))
			.subscribe((adjustment) => {
				this.salePriceAdjustment = adjustment;
			});
	}

	toggleDetails(state: boolean) {
		if (this.salePriceAdjustment?.hstSalePrice) {
			this.salePriceAdjustment.hstSalePrice.details = state;
		} else {
			this.salePriceAdjustment.hstSalePrice = {
				details: state,
			};
		}
	}

	toggleSingleAdjustments(state: boolean) {
		if (this.salePriceAdjustment?.hstSalePrice) {
			this.salePriceAdjustment.hstSalePrice.fedAndProvAsSingleAdjustments =
				state;
		} else {
			this.salePriceAdjustment.hstSalePrice = {
				fedAndProvAsSingleAdjustments: state,
			};
		}
	}

	save() {
		this.adjustmentDispatch.Set(this.salePriceAdjustment);
		this.dialogRef.close();
	}
}
